import { render, staticRenderFns } from "./eventPie.vue?vue&type=template&id=08138d94&scoped=true&"
import script from "./eventPie.vue?vue&type=script&lang=js&"
export * from "./eventPie.vue?vue&type=script&lang=js&"
import style0 from "./eventPie.vue?vue&type=style&index=0&id=08138d94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08138d94",
  null
  
)

export default component.exports